module.exports = __webpack_public_path__ + "static/media/SBPhotography_1-1022w.e2a895ab.jpg";